import type { ComponentProps } from 'react';
import { cn } from '@/lib/utils';

export const fieldBase =
  'w-full rounded-control bg-canvas/60 px-3 text-[14px] text-fg shadow-[inset_0_0_0_1px_var(--color-line-strong)] placeholder:text-fg-subtle transition-shadow outline-none hover:shadow-[inset_0_0_0_1px_rgb(255_255_255/0.2)] focus-visible:shadow-[inset_0_0_0_1px_var(--color-signal)] focus-visible:outline-none aria-invalid:shadow-[inset_0_0_0_1px_var(--color-danger)] disabled:opacity-50';

export function Input({ className, ...props }: ComponentProps<'input'>) {
  return <input className={cn(fieldBase, 'h-10', className)} {...props} />;
}

export function Textarea({ className, ...props }: ComponentProps<'textarea'>) {
  return <textarea className={cn(fieldBase, 'min-h-24 py-2.5 leading-relaxed', className)} {...props} />;
}
